{
  "pageTitle": "Availability import",
  "pageSubtitle": "Upload a file with media unit availability time windows — the import does not change media unit attributes (type, dimensions, price)",
  "accessDenied": "No access to availability import",
  "stepper": {
    "upload": "Upload file",
    "headerRow": "Header row",
    "preview": "Preview",
    "result": "Result"
  },
  "upload": {
    "dropZoneTitle": "Drag a file here or click to select",
    "dropZoneSubtitle": "Supported format: .xlsx, .xls, .xlsm, max. 10 MB",
    "selectFile": "Select file",
    "scopeNote": "This import only saves availability facts within the given time windows (e.g. free / reserved). It does not modify the media unit's own data.",
    "nextButton": "Next",
    "uploading": "Uploading...",
    "errorInvalidFileType": "Unsupported file format. Allowed formats: .xlsx, .xls, .xlsm"
  },
  "headerRow": {
    "heading": "Header row",
    "helperText": "Point to the row that holds the real column names. Auto-detection can pick the wrong row when a note or company header sits above the table.",
    "rowNumberHeader": "Row",
    "previewHeading": "Preview: header and sample data row",
    "previewHeaderRowLabel": "Header",
    "previewSampleRowLabel": "Sample data row",
    "previewNoSampleRow": "No data row directly below the selected row",
    "emptyCellPlaceholder": "—",
    "emptyRowPlaceholder": "Select a row above",
    "headerAutoNoteDetectedTemplate": "Header: row {row} (auto-detected)",
    "headerAutoNoteManualTemplate": "Header: row {row} (picked manually)",
    "headerAutoInfoLabel": "Header-detection info",
    "headerAutoInfoText": "The system automatically picks the first row with at least two non-empty cells. If the file has a note or company header above the table, pick the correct row in the table below.",
    "fileSummaryTemplate": "{sizeKb} KB · ~{rows} rows",
    "fileSummaryTemplateRowsOnly": "~{rows} rows",
    "sheetPickerLabel": "Sheet",
    "back": "Back",
    "nextButton": "Next",
    "loading": "Loading…"
  },
  "preview": {
    "heading": "Detected file profile",
    "helperText": "Review and correct the column mapping if needed",
    "confidentBadge": "High match confidence",
    "lowConfidenceBadge": "Low match confidence — check the fields below",
    "supplierLabel": "Supplier",
    "supplierPlaceholder": "Select supplier…",
    "supplierNumberColumnLabel": "Supplier number",
    "columnPlaceholder": "Select column…",
    "columnMappingTableSystemFieldHeader": "System field",
    "columnMappingTableFileColumnHeader": "File column",
    "columnMappingTableSampleValueHeader": "Example from file",
    "columnMappingTableSampleEmptyPlaceholder": "—",
    "columnMappingOptionalTag": "optional",
    "columnMappingClearOption": "— none —",
    "timeEncodingLabel": "Availability encoding",
    "timeEncodingOptions": {
      "global": "One date range for the whole file",
      "date_range": "Date-from/date-to columns per row",
      "period_label_map": "Column with a period label (map values to dates)",
      "month": "Period columns — build manually"
    },
    "timeEncodingHelp": {
      "triggerLabel": "Explain the availability encoding options",
      "dialogTitle": "How availability is encoded in the file",
      "globalTitle": "One date range for the whole file",
      "globalExplanation": "The file has no date columns at all — you manually pick one date range for the whole file, and every media unit on the list gets exactly that availability period. The date range itself is often stated elsewhere, e.g. in the file name or a message from the supplier, as shown here.",
      "globalExampleFileName": "Offer_Lublin_June_2026.xlsx",
      "globalExampleHeader1": "Supplier number",
      "globalExampleHeader2": "Address",
      "globalExampleHeader3": "Status",
      "globalExampleRow1Cell1": "LL-070-01",
      "globalExampleRow1Cell2": "5 Krakowskie Przedmieście St.",
      "globalExampleRow1Cell3": "Free",
      "dateRangeTitle": "Date-from/date-to columns per row",
      "dateRangeExplanation": "Each media unit (row) carries its own pair of start/end availability date columns — the system reads them directly, with no manual range entry needed.",
      "dateRangeExampleHeader1": "Supplier number",
      "dateRangeExampleHeader2": "Date from",
      "dateRangeExampleHeader3": "Date to",
      "dateRangeExampleHeader4": "Status",
      "dateRangeExampleRow1Cell1": "LL-070-01",
      "dateRangeExampleRow1Cell2": "06/01/2026",
      "dateRangeExampleRow1Cell3": "06/15/2026",
      "dateRangeExampleRow1Cell4": "Free",
      "periodLabelMapTitle": "Column with a period label",
      "periodLabelMapExplanation": "Instead of exact dates, the file has one column with a word-based period description (e.g. a month name) — you manually assign the right date range to each such description, once for the whole file.",
      "periodLabelMapExampleHeader1": "Supplier number",
      "periodLabelMapExampleHeader2": "Period",
      "periodLabelMapExampleRow1Cell1": "LL-070-01",
      "periodLabelMapExampleRow1Cell2": "all of June",
      "monthTitle": "Period columns — build manually",
      "monthExplanation": "The file has a separate column for each period (a full month or a half-month), with the media unit's status value for that period in each cell. The system could not automatically recognize what these column headers mean (e.g. Roman-numeral month numbers) — you manually point out which file column corresponds to which period, and give its exact date range. Full months and half-months can be freely mixed within the same file.",
      "monthExampleHeader1": "Symbol",
      "monthExampleHeader2": "VI",
      "monthExampleHeader3": "1-15 VII",
      "monthExampleHeader4": "16-31 VII",
      "monthExampleHeader5": "VIII",
      "monthExampleRow1Cell1": "LL-070-01",
      "monthExampleRow1Cell2": "rwnj",
      "monthExampleRow1Cell3": "rwnj",
      "monthExampleRow1Cell4": "w ofercie",
      "monthExampleRow1Cell5": "rwnj"
    },
    "statusColumnLabel": "Status",
    "dateFromColumnLabel": "Date from",
    "dateToColumnLabel": "Date to",
    "dateFormatLabel": "Date format",
    "dateFormatCustomPlaceholder": "dd.MM.yyyy",
    "dateFormatCustomHelperText": "e.g. dd.MM.yyyy, yyyy/MM/dd",
    "dateFormatOptions": {
      "auto": "Auto-detected",
      "dd-mm-yyyy": "DD.MM.YYYY",
      "yyyy-mm-dd": "YYYY-MM-DD",
      "excel-serial": "Excel serial number",
      "custom": "Custom…"
    },
    "monthPeriodSectionLabel": "Period columns",
    "monthPeriodPeriodColumnLabel": "Period",
    "monthPeriodSourceColumnLabel": "Source column",
    "monthPeriodYearColumnLabel": "Year",
    "monthPeriodAddRowLabel": "Add period",
    "monthPeriodRemoveRowLabel": "Remove period",
    "monthPeriodEmptyStateText": "No periods defined — add the first one to map a file column",
    "monthPeriodManualRowLabelTemplate": "Period {count}",
    "statusTokenMappingHeading": "Status value mapping",
    "statusTokenMappingHelperText": "The file uses its own availability labels. Specify what each one means in the system — unmapped values will be skipped on import.",
    "statusTokenMappingTokenHeader": "File value",
    "statusTokenMappingOccurrenceHeader": "Occurrence count",
    "statusTokenMappingStateHeader": "System state",
    "statusTokenMappingStatePlaceholder": "Select state",
    "statusTokenMappingUnmappedBadge": "Unmapped",
    "dateRangePlaceholder": "Select date range…",
    "dateRangeColumnLabel": "From - To",
    "globalRangeSectionLabel": "Date range for the whole file",
    "periodLabelColumnLabel": "Column with a period label",
    "periodLabelSectionLabel": "Map period values to dates",
    "periodLabelValueColumnLabel": "Value in file",
    "markRestUnavailableLabel": "Mark the remaining media units of this supplier as unavailable in this period",
    "markRestUnavailableNoteTemplate": "+ {count} other media units of supplier {supplier} will be marked as unavailable in this period",
    "disabledGlobalRangeReason": "Fill in the date range to confirm",
    "disabledPeriodLabelReason": "Map all period values to confirm",
    "disabledSupplierReason": "Select a supplier to confirm",
    "disabledMonthPeriodReason": "Fill in the date range for each period to confirm",
    "disabledDateRangeReason": "Select the date-from and date-to columns to confirm",
    "back": "Back",
    "confirm": "Confirm",
    "confirming": "Confirming…",
    "rowsUnitColumnLabel": "Media unit",
    "rowsPeriodColumnLabel": "Period",
    "rowsStatusColumnLabel": "Status",
    "rowsStatusValues": {
      "FREE": "Free",
      "UNAVAILABLE": "Unavailable"
    },
    "rowsUnmatchedTemplate": "Unmatched ({unit})",
    "rowsUnmatchedTooltip": "No media unit found for this supplier and number",
    "rowsEmptyPlaceholder": "—",
    "rematchFailedWarning": "Failed to re-match rows to media units after the change — the match results may be out of date. Try changing the field again or refresh the page.",
    "rememberedMappingHeading": "Remembered mapping",
    "rememberedMappingDateTemplate": "from {date}",
    "rememberedMappingNoDateFallback": "from a previous import",
    "rememberedMappingResetLabel": "Clear mapping",
    "addressFieldLabel": "Address",
    "cityFieldLabel": "City",
    "unmatchedMappingWarningText": "No row was matched to a media unit. Check the supplier, number, address, and city mapping in the \"Detected file profile\" section.",
    "yearSpanWarningText": "The file\u2019s months resolved to two different years. Review the resolved years in the period table before confirming the import.",
    "disabledUnmatchedMappingReason": "Fix the column mapping to confirm"
  },
  "result": {
    "polling": "Processing file…",
    "headingSuccess": "Import complete",
    "subtitleSuccess": "The media unit availability file has been processed",
    "statUpdated": "Updated",
    "statUnchanged": "Unchanged",
    "statUnmatched": "Unmatched",
    "downloadUnmatchedReport": "Download unmatched report (CSV)",
    "downloadReportFailed": "Failed to download the unmatched rows report",
    "finish": "Finish",
    "headingFailure": "Import failed",
    "failureNote": "No rows were saved. The availability data remains unchanged.",
    "retry": "Try again",
    "errorReportColumnRow": "Row",
    "errorReportColumnGrwId": "GRW number",
    "errorReportColumnField": "Field",
    "errorReportColumnMessage": "Message",
    "errorReportColumnSeverity": "Severity",
    "errorReportColumnSupplierNumber": "Supplier number",
    "errorReportColumnSupplierName": "Supplier",
    "errorReportColumnLatitude": "Latitude",
    "errorReportColumnLongitude": "Longitude",
    "errorReportColumnAddress": "Address",
    "errorReportColumnCity": "City"
  },
  "toasts": {
    "sessionLost": "The preview data was lost — upload the file again.",
    "periodLabelMapIncomplete": "Not all periods have been mapped to dates — check the mapping table.",
    "globalPeriodRequired": "Fill in the date range for the whole file to confirm.",
    "markRestUnavailableOutOfScope": "Marking the remaining media units as unavailable is only available for files with a whole-file date range and a list of free media units.",
    "dateRangeColumnsRequired": "Select the date-from and date-to columns to confirm.",
    "supplierNotResolvable": "Select a supplier column or provide a default supplier to confirm.",
    "monthPeriodColumnsIncomplete": "Fill in the date range for each period to confirm.",
    "allRowsUnmatched": "No row matched a media unit — fix the column mapping before confirming."
  }
}
